/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const e = {
  prefix: "k",
  important: "!",
  rtl: "rtl",
  rounded: "rounded",
  value: "value",
  state: "state",
  filter: "filter",
  virtual: "virtual",
  infinite: "infinite",
  clear: "clear",
  reset: "reset",
  data: "data",
  nodata: "nodata",
  scroller: "scroller"
}, n = {
  center: "center",
  hbox: "hbox",
  vstack: "vstack",
  hstack: "hstack",
  overflow: "overflow"
}, t = {
  actionsheet: "actionsheet",
  calendar: "calendar",
  buttongroup: "buttongroup",
  dateinput: "dateinput",
  datetime: "datetime",
  datetimepicker: "datetimepicker",
  dropdownlist: "dropdownlist",
  combobox: "combobox",
  maskedtextbox: "maskedtextbox",
  menu: "menu",
  searchbox: "searchbox",
  timepicker: "timepicker"
}, l = {
  xsmall: "xs",
  small: "sm",
  medium: "md",
  large: "lg",
  xlarge: "xl",
  xxlarge: "xxl",
  xxxlarge: "xxxl"
}, s = {
  solid: "solid",
  outline: "outline",
  flat: "flat",
  link: "link",
  clear: "clear"
}, c = {
  base: "base",
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  info: "info",
  success: "success",
  warning: "warning",
  error: "error",
  dark: "dark",
  light: "light",
  inherit: "inherit",
  inverse: "inverse"
}, d = {
  small: "sm",
  medium: "md",
  large: "lg",
  full: "full"
}, p = {
  vertical: "vertical",
  horizontal: "horizontal"
}, h = {
  height: "height",
  width: "width"
}, m = {
  default: "cursor-default"
}, f = {
  up: "up",
  down: "down",
  left: "left",
  right: "right",
  start: "start",
  mid: "mid",
  end: "end"
}, r = {
  actions: "actions",
  container: "container",
  content: "content",
  group: "group",
  row: "row",
  nav: "nav",
  wrap: "wrap",
  wrapper: "wrapper",
  list: "list",
  placeholder: "placeholder",
  popup: "popup",
  item: "item",
  part: "part",
  picker: "picker",
  separator: "separator",
  spacer: "spacer",
  tab: "tab",
  titlebar: "titlebar",
  optionLabel: "optionlabel",
  view: "view"
}, a = {
  table: "table",
  text: "text",
  button: "button",
  tbody: "tbody",
  thead: "thead",
  tr: "tr",
  th: "th",
  td: "td",
  header: "header",
  footer: "footer",
  icon: "icon",
  title: "title",
  subtitle: "subtitle",
  link: "link",
  label: "label",
  ul: "ul",
  caption: "caption"
}, u = {
  increase: "increase",
  decrease: "decrease",
  cancel: "cancel",
  accept: "accept",
  split: "split"
}, x = {
  active: "active",
  adaptive: "adaptive",
  first: "first",
  focus: "focus",
  pending: "pending",
  last: "last",
  draggable: "draggable",
  filterable: "filterable",
  grouping: "grouping",
  selected: "selected",
  highlighted: "highlighted",
  disabled: "disabled",
  hidden: "hidden",
  highlight: "highlight",
  invalid: "invalid",
  loading: "loading",
  required: "required",
  checked: "checked",
  empty: "empty",
  scrollable: "scrollable",
  sorted: "sorted",
  sort: "sort",
  sticky: "sticky",
  stretched: "stretched",
  order: "order",
  alt: "alt",
  edit: "edit",
  template: "template",
  shown: "shown",
  horizontal: "horizontal",
  vertical: "vertical",
  fullscreen: "fullscreen",
  bottom: "bottom"
}, g = {
  prefix: "animation",
  child: "child",
  relative: "relative",
  slide: "slide",
  appear: "appear",
  active: "active",
  enter: "enter",
  exit: "exit",
  pushRight: "push-right",
  pushLeft: "push-left",
  pushDown: "push-down",
  pushUp: "push-up",
  expandVertical: "expand-vertical",
  expandHorizontal: "expand-horizontal",
  fade: "fade",
  zoomIn: "zoom-in",
  zoomOut: "zoom-out",
  slideIn: "slide-in",
  slideDown: "slide-down",
  slideUp: "slide-up",
  slideRight: "slide-right",
  slideLeft: "slide-left",
  revealVertical: "reveal-vertical",
  revealHorizontal: "reveal-horizontal",
  "animation-container": "animation-container",
  "animation-container-shown": "animation-container-shown",
  "animation-container-relative": "animation-container-relative",
  "animation-container-fixed": "animation-container-fixed",
  "child-animation-container": "child-animation-container"
}, i = {
  input: "input",
  inner: "inner",
  spin: "spin",
  spinner: "spinner",
  maskedtextbox: "maskedtextbox",
  radio: "radio",
  textbox: "textbox",
  prefix: "prefix",
  suffix: "suffix"
}, b = {
  week: "week",
  weekdays: "weekdays",
  weekend: "weekend",
  month: "month",
  year: "year",
  decade: "decade",
  century: "century",
  // eslint-disable-next-line id-blacklist
  number: "number",
  navigation: "navigation",
  marker: "marker",
  now: "now",
  range: "range",
  today: "today",
  other: "other",
  date: "date",
  time: "time",
  selector: "selector",
  timeselector: "timeselector"
}, v = {
  prefix: "icon",
  svg: "svg",
  i: "i",
  color: "color",
  flipH: "flip-h",
  flipV: "flip-v"
}, w = {
  label: "label",
  text: "text",
  floatingLabel: "floating-label",
  container: "container",
  hint: "form-hint",
  error: "form-error"
}, k = {
  form: "form",
  fieldset: "fieldset",
  legend: "legend",
  separator: "separator",
  field: "field"
}, y = {
  prefix: "popup"
}, o = {
  prefix: "grid",
  ariaRoot: "aria-root",
  tableWrap: "table-wrap",
  master: "master",
  column: "column",
  cell: "cell",
  cellInner: "cell-inner",
  row: "row",
  group: "group",
  hierarchy: "hierarchy",
  detail: "detail",
  noRecords: "norecords",
  pager: "pager"
}, $ = {
  drop: "drop",
  drag: "drag",
  hint: "hint",
  vertical: "v",
  horizontal: "h",
  clue: "clue",
  reorder: "reorder"
}, z = `${e.prefix}-${i.input}`, P = `${e.prefix}-${t.calendar}`, M = `${e.prefix}-${t.maskedtextbox}`, R = `${e.prefix}-${i.radio}`, L = `${e.prefix}-${a.button}`, I = `${e.prefix}-${t.menu}`, D = `${e.prefix}-${r.picker}`, H = `${e.prefix}-${t.dropdownlist}`, U = `${e.prefix}-${t.combobox}`, V = `${e.prefix}-${o.prefix}`, q = {
  base: e,
  actions: u,
  animation: g,
  sizeMap: l,
  components: t,
  cssUtils: n,
  directionMap: f,
  fillModeMap: s,
  themeColorMap: c,
  roundedMap: d,
  orientationMap: p,
  elements: a,
  states: x,
  dimensions: h,
  containers: r,
  cursor: m,
  inputs: i,
  dateInputs: b,
  labels: w,
  forms: k,
  popup: y,
  icon: v,
  grid: o
};
export {
  u as actions,
  g as animationStyles,
  e as base,
  L as buttonPrefix,
  P as calendarPrefix,
  U as comboBoxPrefix,
  t as components,
  r as containers,
  n as cssUtils,
  m as cursor,
  b as dateInputs,
  I as ddbPrefix,
  h as dimensions,
  f as directionMap,
  H as dropDownListPrefix,
  a as elements,
  s as fillModeMap,
  k as forms,
  o as grid,
  V as gridPrefix,
  $ as gridRowReorder,
  v as icon,
  z as inputPrefix,
  i as inputs,
  q as jsonTheme,
  w as labels,
  M as maskedPrefix,
  p as orientationMap,
  D as pickerPrefix,
  y as popup,
  R as radioPrefix,
  d as roundedMap,
  l as sizeMap,
  x as states,
  c as themeColorMap
};
